// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3yXgs","title":"style_title__2YDZ1","link":"style_link__18yTK"};